import { Handle, Position } from "@xyflow/react";
import { BiPlay, BiPlus, BiSkipNext, BiSolidDirectionRight, BiTrash } from "react-icons/bi";
import { MdApps, MdLoop, MdOutlineChecklistRtl, MdWarning, MdWebhook } from "react-icons/md";
import { BsLightningFill } from "react-icons/bs";
import { TbArrowLoopRight, TbClipboardCheck, TbFilter } from "react-icons/tb";
import { CgTimer } from "react-icons/cg";
import { SlDirection, SlDirections } from "react-icons/sl";
import { PiLinkBreak } from "react-icons/pi";

const ConditionalNodes = ({ data, setOpenOverDropdown }) => {
    const handleAdd = (e) => {
        e.stopPropagation();
        data.onAddNext?.(data.id);
    };

    return (
        <div className="default_node trigger_condition">

            <Handle
                type="source"
                position={Position.Right}
                className="custom-handle"
            />

            <Handle
                type="target"
                position={Position.Left}
                className="custom-handle"
            />

            {/* <div className="node_top_hover">
                <button><BiTrash/></button>
            </div> */}

            <div className="custom-node-content">
                <div className="custom-node-title">
                    {data?.nodeType == "if" ? (
                        <i><SlDirection /></i>
                    ) : data?.nodeType == "if_else" ? (
                        <i><SlDirections /></i>
                    ) : data?.nodeType == "if_else_if" ? (
                        <i><SlDirections /></i>
                    ) : data?.nodeType == "switch" ? (
                        <i><MdOutlineChecklistRtl /></i>
                    ) : data?.nodeType == "filter" ? (
                        <i><TbFilter /></i>
                    ) : data?.nodeType == "loop" ? (
                        <><MdLoop /></>
                    ) : data?.nodeType == "while" ? (
                        <i><TbArrowLoopRight /></i>
                    ) : data?.nodeType == "break" ? (
                        <i><PiLinkBreak /></i>
                    ) : (
                        <i><BiSkipNext /></i>
                    )}

                    <span style={{ marginLeft: 6 }}>
                        {data?.meta?.label || "Null"}
                    </span>
                </div>
            </div>

            <div className="node_right_plus" onClick={handleAdd}>
                <BiPlus />
            </div>
        </div>
    );
};

export default ConditionalNodes;